import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { isBulkHiringAssessmentPath } from './features/bulk-hiring/lib/routes';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));
const App = lazy(() => import('./App'));
const PublicPortfolioPage = lazy(
  () => import('./features/candidate-portfolio/PublicPortfolioPage')
);

// Public links must render even when Clerk is unavailable. Keep the signed-in
// providers and application code behind a separate lazy boundary.
export default function ApplicationRoot() {
  const isPublicPortfolio = /^\/talent\/[^/]+\/?$/.test(window.location.pathname);
  return (
    <Suspense fallback={<div role="status">Loading…</div>}>
      {isPublicPortfolio ? (
        <Router>
          <Routes>
            <Route path="/talent/:slug" element={<PublicPortfolioPage />} />
          </Routes>
        </Router>
      ) : // Bulk hiring links (emailed, token in the hash): no Clerk, shell-free.
      isBulkHiringAssessmentPath(window.location.pathname) ? (
        <Router>
          <App />
        </Router>
      ) : (
        <AuthenticatedApp />
      )}
    </Suspense>
  );
}
